import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProTenderService } from './pro-tender.service';
import { ProTenderFormComponent } from './pro-tender-form/pro-tender-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KzFormModule } from '../../../../kz-ui/ui/form/kz-form.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { KzModalModule } from '../../../../kz-ui/ui/modal/kz-modal.module';
import { PhoneCodeModule } from '../../../../shared/components/phone-code/phone-code.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';
import { GoogleMapsUtilsModule } from '../../../../shared/google-maps-utils/google-maps-utils.module';
import { AutocompleteOffModule } from '../../../../utils/directives/autocomplete-off/autocomplete-off.module';
import {
  AuthLightModule
} from '../../../auth/auth-light/auth-light.module';
import { ProTenderSelectComponent } from './pro-tender-select/pro-tender-select.component';
import { ModalsModule } from "../../../../utils/modals/modals.module";
import { ProMiscApiModule } from "@adeo/ngx-kozikaza-api/pro/misc";
import { GtmTrackModule } from "../../../../utils/directives/gtm-track/gtm-track.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KzFormModule,
    NgSelectModule,
    ModalsModule,
    KzModalModule,
    PhoneCodeModule,
    KzIconsModule,
    GoogleMapsUtilsModule,
    AutocompleteOffModule,
    AuthLightModule,
    ProMiscApiModule,
    GtmTrackModule,
  ],
  declarations: [
    ProTenderFormComponent,
    ProTenderSelectComponent,
  ],
  exports: [
    ProTenderSelectComponent,
  ],
  providers: [
    ProTenderService
  ]
})
export class ProTenderModule { }
